<div class="container-padding">
    <mat-card>
        <mat-card-title>{{'Forecast Seasonal Date Ranges' | translate | async}}</mat-card-title>
        <div class="row mt-3">
            <div class="col-md-2">
                <mat-form-field class="w-100">
                    <mat-label>{{'Customer' | translate | async}}</mat-label>
                    <mat-select [(ngModel)]="customerId" (selectionChange)="loadJobsitesForCustomer()">
                        <mat-option *ngFor="let customer of customerList" [value]="customer.Id">
                            {{customer.Name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-md-2" style="display:flex">
                <mat-form-field class="w-100">
                    <mat-label>{{'Jobsite' | translate | async}}</mat-label>
                    <mat-select [(ngModel)]="jobSiteId" (selectionChange)="loadSeasonalDates()">
                        <mat-option *ngFor="let site of jobsiteList" [value]="site.Id">
                            {{site.Name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-spinner diameter="30" *ngIf="loadingJobsite"> </mat-spinner>
            </div>
        </div>

    </mat-card>
    <div class="row card-padding">
        <mat-card class="w-100">
            <mat-card-content>
                <div *ngIf="seasonalDates && seasonalDates.length > 0">
                    <div class="row card-padding">
                        <div class="col-md-8  mt-4">
                            <div class="table-container">
                                <table mat-table [dataSource]="seasonalDates" class="mat-elevation-z2"
                                    style="width:100%">
                                    <ng-container matColumnDef="season">
                                        <th mat-header-cell *matHeaderCellDef> {{ 'Season' | translate | async }}</th>
                                        <td mat-cell *matCellDef="let row">
                                            {{ row.WeatherTypeName }}
                                            <span *ngIf="row.WeatherId === 1 || row.WeatherId === 2"
                                                class="required-asterisk">
                                                *
                                            </span>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="startDate">
                                        <th mat-header-cell *matHeaderCellDef>
                                            {{'Start Date' | translate | async}}
                                        </th>
                                        <td mat-cell *matCellDef="let row">
                                            <div class="d-flex">
                                                <mat-form-field class="me-2" appearance="outline">
                                                    <mat-select [(ngModel)]="row.StartMonth">
                                                        <mat-option *ngFor="let month of months" [value]="month.id">
                                                            {{month.name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                                <mat-form-field appearance="outline">
                                                    <mat-select [(ngModel)]="row.StartDay">
                                                        <mat-option *ngFor="let day of getDays(row.StartMonth)"
                                                            [value]="day">
                                                            {{day}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="endDate">
                                        <th mat-header-cell *matHeaderCellDef>{{'End Date' | translate | async}}</th>
                                        <!-- <td mat-cell *matCellDef="let row">
                                            <mat-form-field appearance="fill">
                                                <input matInput [matDatepicker]="picker2" [(ngModel)]="row.EndDate">
                                                <mat-datepicker-toggle matSuffix
                                                    [for]="picker2"></mat-datepicker-toggle>
                                                <mat-datepicker #picker2></mat-datepicker>
                                            </mat-form-field>
                                        </td> -->
                                        <td mat-cell *matCellDef="let row">

                                            <div class="d-flex">
                                                <mat-form-field class="me-2" appearance="outline">
                                                    <mat-select [(ngModel)]="row.EndMonth">
                                                        <mat-option *ngFor="let month of months" [value]="month.id">
                                                            {{month.name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                                <mat-form-field appearance="outline">
                                                    <mat-select [(ngModel)]="row.EndDay">
                                                        <mat-option *ngFor="let day of getDays(row.EndMonth)"
                                                            [value]="day">
                                                            {{day}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </td>
                                        <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>
                                            {{ 'Action' | translate | async }}
                                        </th>

                                        <td mat-cell *matCellDef="let row">
                                            <button
                                                *ngIf="row.StartMonth || row.StartDay || row.EndMonth || row.EndDay"
                                                mat-icon-button
                                                color="warn"
                                                matTooltip="Reset"
                                                (click)="resetRow(row)">
                                                <mat-icon>restart_alt</mat-icon>
                                            </button>
                                        </td>
                                    </ng-container>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns">
                                    </tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns">
                                    </tr>
                                </table>
                                <div class="single-row">
                                <p class="required-asterisk margin-top" >Note: Any dates outside of the existing values are classified as shoulder season.</p>
                                <div class="table-footer">
                                    <button mat-raised-button color="warn" (click)="save()">
                                        {{'Save' | translate |async}}
                                    </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 text-right mt-4">
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>